// extracted by mini-css-extract-plugin
export default {"wrapper":"ReadOnlyWrapper_wrapper__daLlS"};